<script>
  import chatServico from '~modulos/chat/servico';

  import { modal, tabs, tab } from 'vue-strap';  

  export default {
    components: { modal, tabs, tab },
    props: {
      mostrar: {
        type: Boolean,
        required: true,
      },
      idUsuarioOrigem: {
        type: Number,
        required: true
      },
      nomeUsuarioOrigem: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        erroRepeticaoGrupo: "",
        tabIndex: 0,
        carregando: true,
        configuracao: this.$storage.configuracao(),
        editandoGrupo: false,
        erroValidaUsuario: false,
        usuarioSelecionado: -1,
        salvandoGrupo: false,

        grupos: [],
        usuarios: [],
        usuariosCache: [],

        grupo: this.retornaGrupoVazio(),
      }
    },
    methods: {
      carregarGrupos() {
        return chatServico.carregarGrupos(this.idUsuarioOrigem)
          .then(res => {
            this.grupos = res
          });
      },
      carregarUsuarios() {
        if (this.usuariosCache.length > 0) {
          this.usuarios = this.usuariosCache
          return
        }        

        return chatServico.carregarUsuarios(this.idUsuarioOrigem)
          .then(res => {
            this.usuarios = res
            this.usuariosCache = res
          });
      },
      retornaGrupoVazio() {
        return {
          idChatChannel: 0,
          titulo: "",
          idUsuarioCriacao: this.idUsuarioOrigem,
          usuarios: [{ idUsuario: this.idUsuarioOrigem, nomeUsuario: this.nomeUsuarioOrigem, idChatChannelUsers: 0 }]
        }
      },
      editarGrupo(indexGrupo) {
        this.limparGrupo()
        this.carregarUsuarios()

        if (indexGrupo == -1) {
          this.editandoGrupo = true
          return
        }

        this.grupo = this.grupos.at(indexGrupo)
        this.editandoGrupo = true
      },
      limparGrupo() {
        this.usuarioSelecionado = -1
        this.grupo = this.retornaGrupoVazio()
      },
      validarQuantidadeUsuarios(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (this.grupo.usuarios.length > 1) return true;

        throw new Error("validacao");
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");

        this.salvandoGrupo = true
        const copiaGrupo = JSON.parse(JSON.stringify(this.grupo));

        if (copiaGrupo.idChatChannel != 0) {
          return chatServico.alterar(copiaGrupo);
        } else {
          return chatServico.adicionar(copiaGrupo);
        }
      },
      salvarGrupo() {
        this.validar()
          .then(this.validarQuantidadeUsuarios)
          .then(this.enviar)
          .then(ok => {
            this.salvandoGrupo = false
            toastr.success(`Grupo salvo com sucesso.`);
          })
          .catch(erro => {
            this.salvandoGrupo = false
            if (erro.status === 422) {
              toastr.error('Nome do grupo repetido.')
              this.erroRepeticaoGrupo = 'Nome do grupo repetido.'
            }
          });
      },
      adicionarUsuario() {
        this.erroValidaUsuario = true

        if (this.erroUsuario)
          return

        const usuario = this.usuarios.splice(this.usuarioSelecionado, 1)[0]
        this.grupo.usuarios.push(usuario)
        this.resetarSelecaoUsuario()
      },
      deletarUsuario(index) {
        this.grupo.usuarios.splice(index, 1)
      },
      resetarSelecaoUsuario() {
        this.erroValidaUsuario = false
        this.usuarioSelecionado = -1
      },
      validar() {
        return this.$validator.validateAll();
      },
      voltarListaGrupos() {
        this.editandoGrupo = false
        this.carregarGrupos()
      }
    },
    computed: {
      show() {
        return this.mostrar;
      },
      erroUsuario() {
        return (this.usuarioSelecionado == -1) && this.erroValidaUsuario
      },
      validarUsuarios() {
        return (this.grupo.usuarios.length < 2)
      }
    },
    mounted() {
      this.tabIndex = 0;
      this.carregarUsuarios();
    },
  }
</script>

<template>
  <div >

    <modal ref="modal"
           :value="show"
           effect="fade"
           @closed="$emit('fechado')"
           @opened="carregarGrupos"
           :large="true">
      <div slot="modal-header" class="modal-header">Grupos</div>

      <div class="table-responsive" style="max-height: 350px;" v-if="!editandoGrupo">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Identificador</th>
              <th>Nome do grupo</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(grupo, index) in grupos">
              <td>{{ grupo.idChatChannel }}</td>
              <td>{{ grupo.titulo }}</td>
              <td class="action">
                <button type="button"
                        class="btn btn-secondary btn-xs"
                        v-tooltip="'Editar Grupo'"
                        @click="editarGrupo(index)">
                  <i class="fa fa-pencil"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao" v-else>
        <form @submit.prevent="">
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group required" :class="{'has-error': errors.has('nomegrupo')}">
                <label class="control-label" for="nomegrupo">Nome grupo</label>

                <input type="text"
                       class="form-control"
                       id="nomegrupo"
                       data-vv-name="nomegrupo"
                       v-model="grupo.titulo"
                       v-validate
                       data-vv-rules="required"
                       data-vv-as="nome do grupo"
                       @change="erroRepeticaoGrupo = ''"
                       maxlength="100">

                <p class="text-danger" v-show="errors.has('nomegrupo')">{{ errors.first('nomegrupo') }}</p>
                <p class="text-danger" v-show="erroRepeticaoGrupo">{{ erroRepeticaoGrupo }}</p>
              </div>
            </div>
          </div>

          <div class="row" style="max-height: 250px; overflow-y: auto;">
            <div class="col-xs-12">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(usuario, index) in grupo.usuarios">
                    <td>{{ usuario.nomeUsuario }}</td>
                    <td class="action">
                      <button type="button"
                              v-if="usuario.idUsuario != idUsuarioOrigem"
                              class="btn btn-secondary btn-xs"
                              @click="deletarUsuario(index)"
                              v-tooltip="'Deletar'">
                        <i class="fa fa-eraser"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tfoot v-if="validarUsuarios">
                  <tr>
                    <td colspan="2"><p class="text-danger" style="padding: 0px; margin: 0px;">&Eacute; necess&aacute;rio adicionar pelo menos dois usu&aacute;rios</p></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          <div class="row" style="margin-top: 30px;">
            <div class="col-xs-10">
              <div class="form-group">
                <label class="control-label" for="usuario">Usu&aacute;rio</label>

                <select id="usuario"
                        class="form-control"
                        v-model="usuarioSelecionado"
                        data-vv-name="usuario">
                  <option :value="index"
                          v-for="(usuario, index) in usuarios">
                    {{ usuario.nomeUsuario }} 
                  </option>
                </select>

                <p class="text-danger" v-show="erroUsuario">Selecione um usu&aacute;rio</p>
              </div>
            </div>
            <div class="col-xs-2">
              <div class="form-group">
                <label class="control-label" for="btnAdicionarUsuario"></label>

                <button type="button"
                        id="btnAdicionarUsuario"
                        class="form-control btn btn-primary block full-width m-b"
                        style="margin-top: 5px;"
                        @click="adicionarUsuario">
                  <i class="fa fa-plus-square-o" style="margin-right: 10px;"></i>Adicionar
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div slot="modal-footer" class="modal-footer">
        <div v-if="!editandoGrupo">
          <button id="btnNovo"
                  type="button"
                  class="btn btn-default"
                  @click="editarGrupo(-1)">
            <i class="fa fa-plus-circle"></i> Novo
          </button>

          <button id="btnFechar"
                  type="button"
                  class="btn btn-default"
                  @click="$refs.modal.action(false, 3)">
            <i class="fa fa-times"></i> Fechar
          </button>
        </div>

        <div v-else>
          <button id="btnVoltar"
                  type="button"
                  class="btn btn-default"
                  @click="voltarListaGrupos">
            <i class="fa fa-arrow-left"></i> Voltar
          </button>

          <button id="salvar"
                  type="button"
                  class="btn btn-primary"
                  @click="salvarGrupo"
                  :disabled="salvandoGrupo"
                  data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
            <i class="fa fa-save"></i> Salvar
          </button>
        </div>     
      </div>
    </modal>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/chat/componentes/ModalChatGrupo.vue